import { useState } from "react";
import { useDispatch } from "react-redux";
import { deleteSystemMessages, getSystemMessageUnreadCount, SystemMessageI } from "../../../routes/SystemMessage/systemMessage.ducks";
import { notification, getCroatianPluralForm } from "../../../services";

const getDeleteNotificationMessage = (count: number): string => {
  return `${count} ${getCroatianPluralForm(
    count,
    "poruka je obrisana",
    "poruke su obrisane",
    "poruka je obrisano"
  )}`;
};

export const useDeleteSystemMessages = (messages: SystemMessageI[]) => {
  const dispatch = useDispatch();

  const [isDeleting, setIsDeleting] = useState(false);
  const [selectedMessages, setSelectedMessages] = useState([]);

  const handleBatchDelete = () => {
    if (selectedMessages.length === 0) return;

    setIsDeleting(true);
    dispatch(deleteSystemMessages(selectedMessages, (success, error) => {
      setIsDeleting(false);
      if (success) {
        notification.show(getDeleteNotificationMessage(selectedMessages.length));
        setSelectedMessages([]);
        dispatch(getSystemMessageUnreadCount());
      } else {
        notification.showError("Greška pri brisanju poruka");
      }
    }));
  }

  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedMessages(messages.map(msg => msg.id));
    } else {
      setSelectedMessages([]);
    }
  }

  const isAllSelected = messages.length > 0 && selectedMessages.length === messages.length;

  return {
    isAllSelected,
    handleSelectAll,
    isDeleting,
    setSelectedMessages,
    handleBatchDelete,
    selectedMessages,
  }
}



// WEBPACK FOOTER //
// ./src/containers/ChatsPage/hooks/useDeleteSystemMessages.ts